'use strict';

/// ----------------------------------------------------------------------------------
/// CLASS NEWSLETTER
///
/// Création : 5 mars 2024
/// Dernière révision : 22 mars 2024
/// URL : /informations/newsletter
///
/// Fonctionnalités :
/// - Affichage d'un icon flag en fonction du pays sélectionné
/// - Lightbox événement & choix détail|formulaire
/// - Gestion d'un module tab : AffichageListeEvenements(Agence)
///
/// ----------------------------------------------------------------------------------

class newsletter {
	// Propriétés privées
	#urlAbonnement = '/informations/SetAbonnementNewsletter';
	#urlDesabonnement = '/informations/SetDesabonnementNewsletter';
	#urlEvenement = '/informations/EvenementInformation';

	constructor(config) {

		this.config = config;
		this.pathFlags = this.config.pathFlags ?? '/Content/img/pictos/flags/';
		this.formatFlag =  this.config.formatFlag ?? 'png';
		this.urlAbonnement = this.config.urlAbonnement ?? this.#urlAbonnement;
		this.urlDesabonnement = this.config.urlDesabonnement ?? this.#urlDesabonnement;
		this.hasPublicEvent = this.config.hasPublicEvent ?? false;
		this.hasPrivateEvent = this.config.hasPrivateEvent ?? false;
		this.bodyClass = this.config.bodyClass ?? (settingsApp.page === 'listeconseilleragence' ? 'terdav__esprit' : 'newsletter');
		this.arrayOfEvents = this.config.eventList ?? [];

		this._setArrayOfEvenements()

		// On est sur la page newsletter
		if(settingsApp.page  === 'listeconseilleragence') {
			this.showEvent();
		}
		else if(settingsApp.page  === 'newsletter') {
			// On gère l'icon flag
			settingsApp.app !== 'TCA' && this.setIcon();

			// On set l'array des id evenement
			// document.querySelectorAll('.card--event').forEach((el) => {
			// 	this.arrayOfEvents.push(el.dataset.eventId);
			// })

			// Abonnement
			// Si l'on remplit le champ code postal, il doit être au bon format
			settingsApp.app !== 'TCA' && this._codePostal();
			this._gestionAbonnement('abonnementNewsletter', this.urlAbonnement);

			// On click sur un bouton événement
			// Au chargement de la page l'URL contient un paramètre [Number] `evenement` > 0
			if (this.hasPublicEvent || this.hasPrivateEvent) {
				this.showEvent();

				if(this.hasPublicEvent) {
					// Gestion des onglets agence
					settingsApp.modules.moduleTab.then(() => {
						let Tab = require('modules/tab')
						new Tab({
							header: document.querySelector('.module--tabs'),
							body: document.querySelector('.liste__agences')
						});
					}).catch((e) => {
						console.error(e)
					});
				}
      }
		}

		// On est sur la page désabonnement
		else {
			this._gestionAbonnement('desabonnementNewsletter', this.urlDesabonnement);
		}
	}

///--------------------
///
/// MÉTHODES NEWSLETTER
///
///--------------------
	///
	/// Requête information newsletter
	_gestionAbonnement(id, url) {
		let self = this;
		let form = document.getElementById(id),
		abonnementFormValidation = new Formulaire(this.config);
		abonnementFormValidation.initialize(id);

		form.addEventListener('submit', (e) => {
			e.preventDefault();
			let formData = new URLSearchParams(new FormData(e.target));
			captchaModule.then((module) => {
				let captcha = new module();
				if (abonnementFormValidation._isFormValid(form)) {
					captcha.initialize(self._callback,  {'data' : formData, 'url': url, 'formulaire' : form, 'id': id});
				}
		 });
		})
	}
	///
	/// Appel catpcha
	_callback(obj) {
		let tool = require('common/toolsPromise'),
			promiseTool = new tool();
			promiseTool.optionsPromise = obj.data; // on passe les values dans le body de la requête

		promiseTool.getPromiseJson(obj.url).then((reponse) => {
			if(reponse.MessageError !== null) {
				obj.formulaire.nextElementSibling.innerText = reponse.MessageError
			} else {
				obj.formulaire.nextElementSibling.classList.add('is-valid')
				obj.formulaire.nextElementSibling.innerText = reponse.Message;
			}
		});

		let requestObj = {
			type: 'submit',
			email: obj.data.get('email'),
			libelle: 'Inscription newsletter'
		}
		helpers._dispatchEventSubmitForm(requestObj, '.main');
	}
	///
	/// Validité du champ code postal
	_codePostal() {
		document.querySelector('[name="codePostal"]').addEventListener('keyup', (e) => {
			const {
				target
			} = e;

			if(target.validity.patternMismatch) {
				target.parentElement.classList.add('is-error');
				target.nextElementSibling.innerText = `Seuls les chiffres sont autorisés.`;
			} else {
				target.parentElement.classList.remove('is-error');
				target.nextElementSibling.innerText = ``;
			}

		})
	}
	///
	/// On set le drapeau en fonction du pays sélectionné
	setIcon(){

		document.querySelector('[data-icon-target="flag"] img').src = `${this.pathFlags + document.querySelector('[data-icon="flag"]').value.toLowerCase()}.${this.formatFlag}`;

		document.querySelector('[data-icon="flag"]').addEventListener('change', (e) => {
			const {
				target
			} = e;
			document.querySelector('[data-icon-target="flag"] img').src = `${this.pathFlags + target.value.toLowerCase()}.${this.formatFlag}`;
		})
	}

///--------------------
///
/// MÉTHODES ÉVÉNEMENT
///
///--------------------
	showEvent() {
		let self = this;

		let params = new URLSearchParams(document.location.search);
		let idEvent = params.get('evenement');

		// Si le paramètre evenement de l'URL vaut un number > 0 et que l'événement existe
		// on initie un événement qui va déclencher la popin event
		if(Number(idEvent) && (this.arrayOfEvents.length > 0 && this.arrayOfEvents.includes(idEvent))) {
			self.config.moduleLightBox.then(() => {
				document.querySelector(`.${this.bodyClass}`).dispatchEvent(
					new CustomEvent('lightboxLaunch', {
						bubbles: true,
						detail: {
							libelle: () => {
								return idEvent
							},
							block: () => {
								return 'detail'
							},
							complete: () => {
								return document.querySelector(`[data-event-id="${idEvent}"]`).dataset.eventComplete
							}
						}
					})
				);
			}).catch((error) => {
				console.error(error);
			});
		} else if(params.has('evenement')) {
			if (isNaN(idEvent)) {
				console.error('Parameter evenement is not a number!');
			} else if(Number(idEvent) === 0) {
				console.error('Parameter evenement vaut 0');
			} else if(this.arrayOfEvents.length > 0 && !this.arrayOfEvents.includes(idEvent))  {
				console.error(`L'évenement ${idEvent} n'existe pas`);
			}
		}

		//
		// Tous les boutons `Lire la suite` & `S'incrire` de chaque événement
		document.querySelectorAll('[data-newsletter]').forEach((el) => {
			el.addEventListener('click', function(e) {
				const {
					target
				} = e;

				// Au click, on importe le module lightbox et
				// on créé un événement lightboxLaunch auquel on passe l'id de l'événement
				self.config.moduleLightBox.then(() => {
					target.dispatchEvent(
						new CustomEvent('lightboxLaunch', {
							bubbles: true,
							detail: {
								libelle: () => {
									return target.closest('.card--event').dataset.eventId
								},
								block: () => {
									return target.dataset.newsletter
								},
								complete: () => {
									return target.closest('.card--event').dataset.eventComplete
								}
							}
						})
					);
				}).catch((error) => {
					console.error(error);
				});
			})
		})

		//
		// Ajout listener lightboxLaunch
		document.querySelector(`.${this.bodyClass}`).addEventListener('lightboxLaunch', (e) => {
			let instance = require('modules/lib/basicLightbox.min'),
					optionsLightbox = {
						className: `lightbox--event`,
						onShow: () => {
							document.body.classList.add('lightbox--open');
						},
						onClose: () => {
							document.body.classList.remove('lightbox--open');
							const url = new URL(location);
							url.searchParams.delete('evenement');
							history.pushState({}, "", url);
						}
					};


			tool = require('common/toolsPromise'),
			promiseTool = new tool();

			// On prépare la requête
			let data = `idEvenement=${parseInt(e.detail.libelle())}`;
			promiseTool.optionsPromise = data;
			const url = this.#urlEvenement;

			promiseTool.getPromiseTxt(url)
				.then((data) => {
					const templateInstance = instance.create(data, optionsLightbox);
					templateInstance.show();
				})
				.then(() => {
					let modal = document.querySelector('.event');
					if(e.detail.block() === 'detail') {
						if(!JSON.parse(modal.dataset.eventComplete)) {
							document.querySelector('[for="switchEvent"]').innerText = "S'inscrire à l'événement";
							document.getElementById('formEvenement').hidden = true;
						}
					} else {
						document.querySelector('.event__description').hidden = true;
						document.querySelector('[for="switchEvent"]').innerText = "Consulter le détail";
					}

					// Swicth détail ↭ inscription
					self.switchDetailInscription();

					if(!JSON.parse(modal.dataset.eventComplete)) {
						// Appel du module stepNumber pour le nombre de participants
						const utilities = new stepNumber(this.config);
						utilities.initialize();

						// Gestion du formulaire
						const idForm = 'formEvenement',
									formulaire = new Formulaire(),
									form = document.getElementById(idForm);
						formulaire.initialize(idForm);

						form.addEventListener('submit', (e) => {
							e.preventDefault();
							captchaModule.then((module) => {
								let captcha = new module();
								if (!formulaire._isFormValid(form)) {
									formulaire.validationForm(form);
								} else {
									let formData = new URLSearchParams(new FormData(e.target));
									captcha.initialize(self.inscriptionEvent, {'data' : formData, 'target': e.target, 'formulaire' : form, 'id': 'evenement'});
								}
						 });

						})
					}
					//self.notifMe(`Coucou !\nInscrivez-vous à notre événement ${e.detail.libelle()} et recevez plein de mails !\nToto`);

					// document.getElementById('Nom').addEventListener('invalid', (e) => {
					// 	e.target.setCustomValidity('')
					// 	e.target.nextElementSibling.innerText = 'Toto'
					// })
				});
		});
	}
	inscriptionEvent(obj) {

		promiseTool.optionsPromise = obj.data;
		promiseTool.getPromiseJson(obj.target.action)
		.then((reponse) => {
			if(reponse.Message !== null) {
				let classInfo = parseInt(reponse.MessageValue) == 1 ? 'is-warning' :'is-valid';

				if(obj.formulaire.lastElementChild.classList.contains('notification')) {
					obj.formulaire.lastElementChild.innerText = reponse.Message;
				} else {
					obj.formulaire.insertAdjacentHTML('beforeend', `<div class="notification">${reponse.Message}</div>`);
				}
				obj.formulaire.lastElementChild.classList.add(classInfo);
				document.querySelector('.event').scrollTo(0,document.querySelector('.event').scrollHeight);
			}
		})
	}
	switchDetailInscription() {
		document.getElementById('switchEvent').addEventListener('change', (e) => {
			// Si le block affiché au départ est détail
			if(document.getElementById('formEvenement').hidden) {
				document.getElementById('formEvenement').hidden = false;
				document.querySelector('.event__description').hidden = true;
				document.querySelector('[for="switchEvent"]').innerText = "Consulter le détail";
			} else {
				document.getElementById('formEvenement').hidden = true;
				document.querySelector('.event__description').hidden = false;
				document.querySelector('[for="switchEvent"]').innerText = "S'inscrire à l'événement";
			}
		})
	}

	_setArrayOfEvenements() {
		document.querySelectorAll('.card--event').forEach((el) => {
			//this.arrayOfEvents.push(el.dataset.eventId);

			el.addEventListener('click', (e) => {
				if(e.target.dataset.newsletter) {
					if(document.location.search === '') {
						history.pushState({ page: 1 }, "title 1", `${document.location.search}?evenement=${el.dataset.eventId}`);
					} else {
						history.pushState({ page: 1 }, "title 1", `${document.location.search}&evenement=${el.dataset.eventId}`);
					}
				}
			})
		});
	}

	/*
	notifMe(msg) {

		const img = "/content/img/informations/newsletter/test/frans-hulet-j0WTZ6HWfCU-unsplash.jpg";

		if (window.Notification && Notification.permission === "granted") {
			const notification = new Notification("Ne ratez pas cette superbe conférence", {
				body: msg,
				icon: img
			});
		}
		else if (window.Notification && Notification.permission !== "denied") {
			Notification.requestPermission(function (status) {
				if (status=== "granted") {
					const notification = new Notification("Ne ratez pas cette superbe conférence", {
						body: msg,
						icon: img
					});
				}
				// else {
				// 	alert(msg);
				// }
			})
		}
		// else {
		// 	alert(msg);
		// }
	}*/
}